export const getBlogPostDataQuery = (slug: string) => {
    return `*[_type=="post" && slug.current == "${slug}"] {
                _id, 
                title, 
                excerpt, 
                content, 
                "slug": slug.current, 
                image, 
                dateOfCreation, 
                _updatedAt, 
                metaTitle,
                metaDescription,
                ogImage,
                "estimatedReadingTime": round(length(pt::text(content)) / 5 / 275 ),
                tags[] -> { 
                    _id, 
                    title, 
                    "slug": slug.current 
                },
                readNextPosts[] -> {
                    title,
                    "slug": slug.current, 
                    image, 
                    dateOfCreation, 
                    _updatedAt, 
                }
            }[0]`;
};
